import styled from 'styled-components'

export const Content = styled.div`
  min-width: 100vw;
  min-height: 100vh;

  display: flex;
`

export const LoadingView = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const LoadingText = styled.h3`
  font-size: 16px;
`
